export default __webpack_public_path__ + "static/media/GiftCard_Cart.b11a3ba1.svg";